import { endpoint, dateToServer } from 'services/Api';

/**
 * Resource Endpoint.
 *
 * @type {String}
 */
const RESOURCE = 'documents';

/**
 * Multipliers Mini Calculator Endpoints:
 */
export default {
    search(name, category, orderBy) {
        return endpoint(`${RESOURCE}`, 'search', {name, category, orderBy});
    },
    /**
     * Get the documents
     *
     * @return {Promise}
     */
    all() {
        return endpoint(`${RESOURCE}`, 'all');
    },
};



// WEBPACK FOOTER //
// ./src/services/api/resources/documents.js